import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import associateServices from "../../../services";
import Loading from "../../../components/loading";
import Countback from "../../../components/countback";
import {toast} from "react-toastify";
import InformationToast from "../../../components/toast/InformationToast";

const SelfExclusionStep1 = props => {

    const {reFetch, data} = props
    const {t} = useTranslation()

    const [loading, setLoading] = useState(false)


    const handleTakeBreak = () => {
        setLoading(true)
        associateServices.activateSelfExclusion({
            period: '24-hours'
        }).then(res => {
            setLoading(false)

            if (res?.status !== 200) {
                toast(<InformationToast
                    icon={'ti-info-circle'}
                    title={t(`general.information`)}
                    message={t(`api-notifications.${res?.data}`)}
                />)
            } else{
                toast(<InformationToast
                    icon={'ti-info-circle'}
                    title={t(`general.information`)}
                    message={t(`api-notifications.${res?.data}`)}
                />)
                reFetch()
            }
        })
    }


    return (
        <div className="settings">
                <span className="settings__level">
                {t('self-exclusion.step-1')}
                </span>

            <p className="settings__text">
                {t('self-exclusion.step-1-desc')}
            </p>

            {
                data?.excluded_till ?
                    <Countback nextDate={data?.excluded_till} showDesc={false} showTitle={false}/>
                    :
                    <div className="settings__actions">
                        <div className="settings__btns">

                            {
                                loading ? <Loading/> :

                                    <button
                                        disabled={loading}
                                        onClick={handleTakeBreak}
                                        className="settings__btn" type="button">
                                        {t('self-exclusion.take-break')}
                                    </button>
                            }
                        </div>
                    </div>
            }


        </div>

    )

}

export default SelfExclusionStep1
